import React from 'react';
import classNames from 'classnames';
import { Link } from 'modules/i18n';

type CVThequeProps = React.HTMLAttributes<HTMLDivElement> & {
  cities: string[];
};

const CVThequeCities: React.FC<CVThequeProps> = ({ children, className, cities, ...props }) => {
  return (
    <div className={classNames('container mx-auto py-8', className)} {...props}>
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">CVTheque Off-Market par ville</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {cities.map((city) => {
            const cleanCity = city.replace(/\s*-\s*\d{4,5}$/, '');
            return (
              <Link key={city} href={`/cvtheque/ville/${encodeURIComponent(cleanCity)}`} className="justify-start link">
                Candidats Off-Market à <strong>{cleanCity}</strong>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CVThequeCities;
